import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import useSEO from '@/hooks/useSEO';

export default function NotFound() {
  const { t, i18n } = useTranslation('common');
  const currentLang = i18n.language || 'en';

  useSEO({
    title: 'Page Not Found – AllChinaBuy Spreadsheet',
    description: 'The page you are looking for does not exist. Explore AllChinaBuy spreadsheet resources, buying guides, and product categories.',
    canonical: 'https://allchinabuyspread.hair/404',
    lang: currentLang,
  });

  return (
    <div className="min-h-screen bg-background-50 flex flex-col">
      <Navbar />
      <div className="flex-1 flex items-center justify-center px-4 pt-20">
        <div className="text-center max-w-md">
          <div className="w-20 h-20 rounded-xl bg-primary-100 flex items-center justify-center mx-auto mb-6">
            <i className="ri-error-warning-line text-primary-500 text-3xl" />
          </div>
          <h1 className="font-heading text-4xl md:text-5xl font-bold text-foreground-900 mb-4">
            404
          </h1>
          <p className="text-foreground-600 mb-2">
            {t('pageNotFound')}
          </p>
          <p className="text-sm text-foreground-500 mb-8">
            {t('pageNotFoundDesc')}
          </p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Link to={`/${currentLang}`} className="btn-primary gap-2">
              <i className="ri-home-line" />
              {t('backToHome')}
            </Link>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="btn-secondary gap-2"
            >
              <i className="ri-external-link-line" />
              {t('visitMain')}
            </a>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}